import { render, staticRenderFns } from "./KeyFigureBlock.vue?vue&type=template&id=08934d44"
import script from "./KeyFigureBlock.vue?vue&type=script&lang=js"
export * from "./KeyFigureBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports